import PropTypes from 'prop-types';
import React, { Component } from 'react';

var SignalStrength = {
  'EXCELLENT': 'EXCELLENT',
  'GREAT': 'GREAT',
  'OKAY': 'OKAY',
  'WEAK': 'WEAK',
  'UNUSABLE': 'UNUSABLE',
  'DISCONNECTED': 'DISCONNECTED'
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var _PropTypes$shape;

var propTypes = {
  strength: PropTypes.oneOf([SignalStrength.EXCELLENT, SignalStrength.GREAT, SignalStrength.OKAY, SignalStrength.WEAK, SignalStrength.UNUSABLE, SignalStrength.DISCONNECTED]).isRequired,
  statusImages: PropTypes.shape((_PropTypes$shape = {}, defineProperty(_PropTypes$shape, SignalStrength.EXCELLENT, PropTypes.string.isRequired), defineProperty(_PropTypes$shape, SignalStrength.GREAT, PropTypes.string.isRequired), defineProperty(_PropTypes$shape, SignalStrength.OKAY, PropTypes.string.isRequired), defineProperty(_PropTypes$shape, SignalStrength.WEAK, PropTypes.string.isRequired), defineProperty(_PropTypes$shape, SignalStrength.UNUSABLE, PropTypes.string.isRequired), defineProperty(_PropTypes$shape, SignalStrength.DISCONNECTED, PropTypes.string.isRequired), _PropTypes$shape)),
  style: PropTypes.object,
  alt: PropTypes.string
};

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h255.73v255.47H0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M252.89 79.65a10.43 10.43 0 0 1-4 14.67l-.11.06c-4.48 2.19-8.61 1.42-12.53-1.69-7.82-6.21-15.41-12.79-23.73-18.26-45.46-29.88-93-31.71-142-9.61a194.31 194.31 0 0 0-48.97 31.53c-5.53 4.87-12.17 4.78-16.41-.13s-3.71-11.35 1.67-16c37.45-32.09 79.9-52.13 130.11-51.84 38.62.23 72.26 14.74 102.31 38.32a111.35 111.35 0 0 1 11 9.36 18.7 18.7 0 0 1 2.66 3.59z",
  transform: "translate(.08 -.12)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M131.66 81.14c33 .72 62.18 11.34 86.48 34.2 5.47 5.16 6.31 11.64 2.06 16.26s-10.26 4.5-16-.37c-17.45-14.89-37-25.3-60-28.33-27.88-3.66-52.61 4.35-75.2 20.23-3.67 2.58-7.1 5.5-10.56 8.37-5.44 4.5-11.44 4.61-15.6.17-4.3-4.62-3.79-10.83 1.53-15.89 20.07-19.09 43.95-30.15 71.38-33.68 2.8-.36 5.61-.75 8.43-.93 2.48-.17 4.99-.03 7.48-.03z",
  transform: "translate(.08 -.12)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M122.39 131.51a68.14 68.14 0 0 1 17.59-.09c17.61 2.26 33.46 9 46.35 22.88a10.35 10.35 0 0 1 0 14.47c-3.88 4-9.82 4.4-14.38.46-8.81-7.62-18.41-13.7-30-16.08-17.59-3.61-32.8 1.84-46.56 12.53-1.71 1.32-3.26 2.85-5 4.14-4.82 3.63-10.39 3.18-14.33-1.19-3.69-4.09-3.76-9.54.24-14 11.24-12.44 25.47-19.48 41.8-22.5 1.42-.22 2.84-.43 4.29-.62zM131.46 181a27.18 27.18 0 0 1 27.09 26.88c.07 14.58-12.33 27.18-26.83 27.28-14.69.1-27.2-12.12-27.33-26.71A27.28 27.28 0 0 1 131.46 181zm8.38 27a8 8 0 0 0-15.92-.24 8 8 0 1 0 15.92.24z",
  transform: "translate(.08 -.12)"
});

var EXCELLENT = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20255.73%20255.47%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%239abc22%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Ctitle%3Ewifi5%3C%2Ftitle%3E%3Crect%20class%3D%22cls-1%22%20width%3D%22255.73%22%20height%3D%22255.47%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M252.89%2C79.65a10.43%2C10.43%2C0%2C0%2C1-4%2C14.67l-.11.06c-4.48%2C2.19-8.61%2C1.42-12.53-1.69-7.82-6.21-15.41-12.79-23.73-18.26-45.46-29.88-93-31.71-142-9.61A194.31%2C194.31%2C0%2C0%2C0%2C21.55%2C96.35c-5.53%2C4.87-12.17%2C4.78-16.41-.13s-3.71-11.35%2C1.67-16c37.45-32.09%2C79.9-52.13%2C130.11-51.84%2C38.62.23%2C72.26%2C14.74%2C102.31%2C38.32a111.35%2C111.35%2C0%2C0%2C1%2C11%2C9.36A18.7%2C18.7%2C0%2C0%2C1%2C252.89%2C79.65Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M131.66%2C81.14c33%2C.72%2C62.18%2C11.34%2C86.48%2C34.2%2C5.47%2C5.16%2C6.31%2C11.64%2C2.06%2C16.26s-10.26%2C4.5-16-.37c-17.45-14.89-37-25.3-60-28.33-27.88-3.66-52.61%2C4.35-75.2%2C20.23-3.67%2C2.58-7.1%2C5.5-10.56%2C8.37C53%2C136%2C47%2C136.11%2C42.84%2C131.67c-4.3-4.62-3.79-10.83%2C1.53-15.89C64.44%2C96.69%2C88.32%2C85.63%2C115.75%2C82.1c2.8-.36%2C5.61-.75%2C8.43-.93C126.66%2C81%2C129.17%2C81.14%2C131.66%2C81.14Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M122.39%2C131.51a68.14%2C68.14%2C0%2C0%2C1%2C17.59-.09c17.61%2C2.26%2C33.46%2C9%2C46.35%2C22.88a10.35%2C10.35%2C0%2C0%2C1%2C0%2C14.47c-3.88%2C4-9.82%2C4.4-14.38.46-8.81-7.62-18.41-13.7-30-16.08-17.59-3.61-32.8%2C1.84-46.56%2C12.53-1.71%2C1.32-3.26%2C2.85-5%2C4.14C85.57%2C173.45%2C80%2C173%2C76.06%2C168.63c-3.69-4.09-3.76-9.54.24-14%2C11.24-12.44%2C25.47-19.48%2C41.8-22.5C119.52%2C131.91%2C120.94%2C131.7%2C122.39%2C131.51Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M131.46%2C181a27.18%2C27.18%2C0%2C0%2C1%2C27.09%2C26.88c.07%2C14.58-12.33%2C27.18-26.83%2C27.28-14.69.1-27.2-12.12-27.33-26.71A27.28%2C27.28%2C0%2C0%2C1%2C131.46%2C181Zm8.38%2C27a8%2C8%2C0%2C0%2C0-15.92-.24%2C8%2C8%2C0%2C1%2C0%2C15.92.24Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3C%2Fsvg%3E";

var _ref$1 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2$1 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h255.73v255.47H0z"
});

var _ref3$1 =
/*#__PURE__*/
React.createElement("path", {
  d: "M252.84 79.93a10.42 10.42 0 0 1-4 14.67l-.12.06c-4.48 2.2-8.6 1.43-12.53-1.69-7.82-6.2-15.41-12.79-23.72-18.25-45.46-29.88-93-31.71-142-9.61A194.49 194.49 0 0 0 21.5 96.64c-5.5 4.86-12.17 4.78-16.4-.14s-3.72-11.35 1.67-16c37.45-32.06 79.9-52.1 130.11-51.8 38.62.22 72.26 14.73 102.31 38.32a111 111 0 0 1 11 9.36 18.94 18.94 0 0 1 2.65 3.55z",
  transform: "translate(.08 -.12)",
  fill: "#d2d2d2"
});

var _ref4$1 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M131.62 81.43c33 .71 62.18 11.33 86.47 34.2 5.48 5.15 6.31 11.64 2.07 16.26s-10.27 4.49-16-.37c-17.44-14.89-37-25.31-60-28.33-27.86-3.67-52.6 4.34-75.16 20.23-3.67 2.58-7.11 5.5-10.56 8.36C53 136.29 47 136.4 42.8 132c-4.31-4.61-3.79-10.82 1.53-15.89C64.4 97 88.28 85.91 115.7 82.38c2.81-.36 5.61-.75 8.43-.92 2.49-.16 4.99-.03 7.49-.03z",
  transform: "translate(.08 -.12)"
});

var _ref5$1 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M129.68 130.88c21.71.76 41.27 7.21 56.6 23.7a10.34 10.34 0 0 1 0 14.47c-3.88 4-9.81 4.4-14.37.46-8.81-7.62-18.41-13.7-30-16.08-17.59-3.61-32.79 1.84-46.55 12.53-1.71 1.33-3.26 2.85-5 4.15-4.84 3.62-10.45 3.12-14.35-1.19-3.7-4.09-3.76-9.55.23-14 11.25-12.44 25.48-19.48 41.81-22.49 3.76-.66 7.58-1.01 11.63-1.55zM131.42 181.25a27.2 27.2 0 0 1 27.09 26.89c.07 14.58-12.33 27.18-26.84 27.27-14.69.1-27.19-12.12-27.33-26.71a27.3 27.3 0 0 1 27.08-27.45zm8.38 27a8 8 0 0 0-15.92-.24 8 8 0 1 0 15.92.24z",
  transform: "translate(.08 -.12)"
});

var GREAT = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20255.73%20255.47%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23d2d2d2%3B%7D.cls-3%7Bfill%3A%239abc22%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Ctitle%3Ewifi4%3C%2Ftitle%3E%3Crect%20class%3D%22cls-1%22%20width%3D%22255.73%22%20height%3D%22255.47%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M252.84%2C79.93a10.42%2C10.42%2C0%2C0%2C1-4%2C14.67l-.12.06c-4.48%2C2.2-8.6%2C1.43-12.53-1.69-7.82-6.2-15.41-12.79-23.72-18.25-45.46-29.88-93-31.71-142-9.61A194.49%2C194.49%2C0%2C0%2C0%2C21.5%2C96.64C16%2C101.5%2C9.33%2C101.42%2C5.1%2C96.5s-3.72-11.35%2C1.67-16C44.22%2C48.44%2C86.67%2C28.4%2C136.88%2C28.7c38.62.22%2C72.26%2C14.73%2C102.31%2C38.32a111%2C111%2C0%2C0%2C1%2C11%2C9.36A18.94%2C18.94%2C0%2C0%2C1%2C252.84%2C79.93Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-3%22%20d%3D%22M131.62%2C81.43c33%2C.71%2C62.18%2C11.33%2C86.47%2C34.2%2C5.48%2C5.15%2C6.31%2C11.64%2C2.07%2C16.26s-10.27%2C4.49-16-.37c-17.44-14.89-37-25.31-60-28.33C116.3%2C99.52%2C91.56%2C107.53%2C69%2C123.42c-3.67%2C2.58-7.11%2C5.5-10.56%2C8.36C53%2C136.29%2C47%2C136.4%2C42.8%2C132c-4.31-4.61-3.79-10.82%2C1.53-15.89C64.4%2C97%2C88.28%2C85.91%2C115.7%2C82.38c2.81-.36%2C5.61-.75%2C8.43-.92C126.62%2C81.3%2C129.12%2C81.43%2C131.62%2C81.43Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-3%22%20d%3D%22M129.68%2C130.88c21.71.76%2C41.27%2C7.21%2C56.6%2C23.7a10.34%2C10.34%2C0%2C0%2C1%2C0%2C14.47c-3.88%2C4-9.81%2C4.4-14.37.46-8.81-7.62-18.41-13.7-30-16.08-17.59-3.61-32.79%2C1.84-46.55%2C12.53-1.71%2C1.33-3.26%2C2.85-5%2C4.15-4.84%2C3.62-10.45%2C3.12-14.35-1.19-3.7-4.09-3.76-9.55.23-14%2C11.25-12.44%2C25.48-19.48%2C41.81-22.49C121.81%2C131.77%2C125.63%2C131.42%2C129.68%2C130.88Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-3%22%20d%3D%22M131.42%2C181.25a27.2%2C27.2%2C0%2C0%2C1%2C27.09%2C26.89c.07%2C14.58-12.33%2C27.18-26.84%2C27.27-14.69.1-27.19-12.12-27.33-26.71A27.3%2C27.3%2C0%2C0%2C1%2C131.42%2C181.25Zm8.38%2C27a8%2C8%2C0%2C0%2C0-15.92-.24%2C8%2C8%2C0%2C1%2C0%2C15.92.24Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3C%2Fsvg%3E";

var _ref$2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2$2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h255.73v255.47H0z"
});

var _ref3$2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M251.8 80.14a10.43 10.43 0 0 1-4 14.67l-.11.06c-4.48 2.19-8.61 1.42-12.53-1.69-7.85-6.18-15.44-12.79-23.76-18.26-45.46-29.88-93-31.71-142-9.61a194.55 194.55 0 0 0-48.95 31.53c-5.52 4.87-12.16 4.78-16.4-.13s-3.71-11.35 1.67-16c37.45-32.06 79.9-52.1 130.11-51.81 38.62.23 72.26 14.74 102.31 38.32a111.35 111.35 0 0 1 11 9.36 18.7 18.7 0 0 1 2.66 3.56z",
  transform: "translate(.08 -.12)"
});

var _ref4$2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M130.57 81.63c33 .72 62.18 11.34 86.48 34.2 5.47 5.15 6.31 11.64 2.06 16.26s-10.26 4.49-16-.37c-17.45-14.89-37-25.3-60-28.33-27.88-3.66-52.61 4.35-75.2 20.23-3.67 2.58-7.1 5.5-10.56 8.37-5.42 4.5-11.46 4.61-15.62.17-4.3-4.62-3.79-10.83 1.53-15.89 20.07-19.09 44-30.16 71.38-33.68 2.8-.36 5.61-.75 8.43-.93 2.5-.15 5.01-.03 7.5-.03z",
  transform: "translate(.08 -.12)"
});

var _ref5$2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M123.27 131.75a56.93 56.93 0 0 1 12.65-.18c18.8 1.86 35.72 8.59 49.32 23.22a10.35 10.35 0 0 1 0 14.47c-3.88 4.05-9.82 4.4-14.38.45-8.81-7.61-18.41-13.7-30-16.07-17.59-3.61-32.8 1.84-46.56 12.53-1.71 1.32-3.26 2.85-5 4.14-4.84 3.63-10.45 3.13-14.35-1.19-3.69-4.09-3.76-9.54.24-14 11.24-12.44 25.47-19.48 41.8-22.5 2.08-.34 4.16-.62 6.28-.87zM130.37 181.45a27.2 27.2 0 0 1 27.09 26.89c.07 14.58-12.33 27.18-26.83 27.28-14.69.1-27.2-12.12-27.33-26.71a27.29 27.29 0 0 1 27.07-27.46zm8.38 27a8 8 0 0 0-15.92-.24 8 8 0 1 0 15.92.24z",
  transform: "translate(.08 -.12)"
});

var OKAY = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20255.73%20255.47%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23d2d2d2%3B%7D.cls-3%7Bfill%3A%239abc22%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Ctitle%3Ewifi3%3C%2Ftitle%3E%3Crect%20class%3D%22cls-1%22%20width%3D%22255.73%22%20height%3D%22255.47%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M251.8%2C80.14a10.43%2C10.43%2C0%2C0%2C1-4%2C14.67l-.11.06c-4.48%2C2.19-8.61%2C1.42-12.53-1.69C227.31%2C87%2C219.72%2C80.39%2C211.4%2C74.92c-45.46-29.88-93-31.71-142-9.61A194.55%2C194.55%2C0%2C0%2C0%2C20.45%2C96.84c-5.52%2C4.87-12.16%2C4.78-16.4-.13s-3.71-11.35%2C1.67-16C43.17%2C48.65%2C85.62%2C28.61%2C135.83%2C28.9c38.62.23%2C72.26%2C14.74%2C102.31%2C38.32a111.35%2C111.35%2C0%2C0%2C1%2C11%2C9.36A18.7%2C18.7%2C0%2C0%2C1%2C251.8%2C80.14Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M130.57%2C81.63c33%2C.72%2C62.18%2C11.34%2C86.48%2C34.2%2C5.47%2C5.15%2C6.31%2C11.64%2C2.06%2C16.26s-10.26%2C4.49-16-.37c-17.45-14.89-37-25.3-60-28.33-27.88-3.66-52.61%2C4.35-75.2%2C20.23-3.67%2C2.58-7.1%2C5.5-10.56%2C8.37-5.42%2C4.5-11.46%2C4.61-15.62.17-4.3-4.62-3.79-10.83%2C1.53-15.89%2C20.07-19.09%2C44-30.16%2C71.38-33.68%2C2.8-.36%2C5.61-.75%2C8.43-.93C125.57%2C81.51%2C128.08%2C81.63%2C130.57%2C81.63Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-3%22%20d%3D%22M123.27%2C131.75a56.93%2C56.93%2C0%2C0%2C1%2C12.65-.18c18.8%2C1.86%2C35.72%2C8.59%2C49.32%2C23.22a10.35%2C10.35%2C0%2C0%2C1%2C0%2C14.47c-3.88%2C4.05-9.82%2C4.4-14.38.45-8.81-7.61-18.41-13.7-30-16.07-17.59-3.61-32.8%2C1.84-46.56%2C12.53-1.71%2C1.32-3.26%2C2.85-5%2C4.14-4.84%2C3.63-10.45%2C3.13-14.35-1.19-3.69-4.09-3.76-9.54.24-14%2C11.24-12.44%2C25.47-19.48%2C41.8-22.5C119.07%2C132.28%2C121.15%2C132%2C123.27%2C131.75Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-3%22%20d%3D%22M130.37%2C181.45a27.2%2C27.2%2C0%2C0%2C1%2C27.09%2C26.89c.07%2C14.58-12.33%2C27.18-26.83%2C27.28-14.69.1-27.2-12.12-27.33-26.71A27.29%2C27.29%2C0%2C0%2C1%2C130.37%2C181.45Zm8.38%2C27a8%2C8%2C0%2C0%2C0-15.92-.24%2C8%2C8%2C0%2C1%2C0%2C15.92.24Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3C%2Fsvg%3E";

var _ref$3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2$3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h255.73v255.47H0z"
});

var _ref3$3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M252.21 79.91a10.43 10.43 0 0 1-4 14.67l-.11.06c-4.48 2.19-8.61 1.42-12.53-1.69-7.82-6.21-15.41-12.79-23.73-18.26-45.46-29.88-93-31.71-142-9.61a194.55 194.55 0 0 0-48.98 31.53c-5.52 4.87-12.16 4.78-16.4-.13s-3.71-11.35 1.67-16C43.58 48.42 86 28.38 136.24 28.67c38.62.23 72.26 14.74 102.31 38.33a111.35 111.35 0 0 1 11 9.36 18.7 18.7 0 0 1 2.66 3.55z",
  transform: "translate(.08 -.12)"
});

var _ref4$3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M131 81.4c33 .72 62.18 11.34 86.48 34.2 5.47 5.16 6.31 11.64 2.06 16.26s-10.26 4.5-16-.37c-17.45-14.89-37-25.3-60-28.33-27.88-3.66-52.61 4.35-75.2 20.23-3.67 2.58-7.1 5.5-10.56 8.37-5.42 4.51-11.46 4.61-15.62.17-4.3-4.62-3.79-10.83 1.53-15.89 20.07-19.09 44-30.15 71.38-33.68 2.8-.36 5.61-.75 8.43-.93 2.5-.15 4.99-.03 7.5-.03z",
  transform: "translate(.08 -.12)"
});

var _ref5$3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M129.05 130.86c21.7.76 41.26 7.2 56.6 23.7a10.35 10.35 0 0 1 0 14.47c-3.88 4.05-9.82 4.4-14.38.46-8.81-7.62-18.41-13.7-30-16.08-17.59-3.61-32.8 1.84-46.56 12.53-1.71 1.32-3.26 2.85-5 4.14-4.84 3.63-10.45 3.13-14.35-1.19-3.69-4.09-3.76-9.54.24-14 11.24-12.44 25.47-19.48 41.8-22.5 3.77-.65 7.6-.99 11.65-1.53z",
  transform: "translate(.08 -.12)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.78 181.23a27.18 27.18 0 0 1 27.09 26.88c.07 14.58-12.33 27.18-26.83 27.28-14.69.1-27.2-12.12-27.33-26.71a27.28 27.28 0 0 1 27.07-27.45zm8.38 27a8 8 0 0 0-15.92-.24 8 8 0 1 0 15.92.24z",
  transform: "translate(.08 -.12)",
  fill: "#9abc22"
});

var WEAK = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20255.73%20255.47%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23d2d2d2%3B%7D.cls-3%7Bfill%3A%239abc22%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Ctitle%3Ewifi2%3C%2Ftitle%3E%3Crect%20class%3D%22cls-1%22%20width%3D%22255.73%22%20height%3D%22255.47%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M252.21%2C79.91a10.43%2C10.43%2C0%2C0%2C1-4%2C14.67l-.11.06c-4.48%2C2.19-8.61%2C1.42-12.53-1.69-7.82-6.21-15.41-12.79-23.73-18.26-45.46-29.88-93-31.71-142-9.61A194.55%2C194.55%2C0%2C0%2C0%2C20.86%2C96.61c-5.52%2C4.87-12.16%2C4.78-16.4-.13s-3.71-11.35%2C1.67-16C43.58%2C48.42%2C86%2C28.38%2C136.24%2C28.67%2C174.86%2C28.9%2C208.5%2C43.41%2C238.55%2C67a111.35%2C111.35%2C0%2C0%2C1%2C11%2C9.36A18.7%2C18.7%2C0%2C0%2C1%2C252.21%2C79.91Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M131%2C81.4c33%2C.72%2C62.18%2C11.34%2C86.48%2C34.2%2C5.47%2C5.16%2C6.31%2C11.64%2C2.06%2C16.26s-10.26%2C4.5-16-.37c-17.45-14.89-37-25.3-60-28.33-27.88-3.66-52.61%2C4.35-75.2%2C20.23-3.67%2C2.58-7.1%2C5.5-10.56%2C8.37-5.42%2C4.51-11.46%2C4.61-15.62.17-4.3-4.62-3.79-10.83%2C1.53-15.89%2C20.07-19.09%2C44-30.15%2C71.38-33.68%2C2.8-.36%2C5.61-.75%2C8.43-.93C126%2C81.28%2C128.49%2C81.4%2C131%2C81.4Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M129.05%2C130.86c21.7.76%2C41.26%2C7.2%2C56.6%2C23.7a10.35%2C10.35%2C0%2C0%2C1%2C0%2C14.47c-3.88%2C4.05-9.82%2C4.4-14.38.46-8.81-7.62-18.41-13.7-30-16.08-17.59-3.61-32.8%2C1.84-46.56%2C12.53-1.71%2C1.32-3.26%2C2.85-5%2C4.14-4.84%2C3.63-10.45%2C3.13-14.35-1.19-3.69-4.09-3.76-9.54.24-14%2C11.24-12.44%2C25.47-19.48%2C41.8-22.5C121.17%2C131.74%2C125%2C131.4%2C129.05%2C130.86Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-3%22%20d%3D%22M130.78%2C181.23a27.18%2C27.18%2C0%2C0%2C1%2C27.09%2C26.88c.07%2C14.58-12.33%2C27.18-26.83%2C27.28-14.69.1-27.2-12.12-27.33-26.71A27.28%2C27.28%2C0%2C0%2C1%2C130.78%2C181.23Zm8.38%2C27a8%2C8%2C0%2C0%2C0-15.92-.24%2C8%2C8%2C0%2C1%2C0%2C15.92.24Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3C%2Fsvg%3E";

var _ref$4 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2$4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h255.73v255.47H0z"
});

var _ref3$4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M254.09 84.41a9.81 9.81 0 0 1-5.86 10.06c-4.48 2.2-8.6 1.43-12.53-1.69-7.82-6.2-15.41-12.78-23.7-18.25-45.47-29.88-93-31.71-142-9.61a194.49 194.49 0 0 0-49 31.53c-5.52 4.86-12.17 4.78-16.41-.13S.91 85 6.3 80.35c37.45-32.1 79.9-52.13 130.11-51.84 38.62.22 72.26 14.73 102.31 38.32a112.39 112.39 0 0 1 11 9.36 16.4 16.4 0 0 1 4.37 8.22z",
  transform: "translate(.08 -.12)"
});

var _ref4$4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M131.15 81.24c33 .71 62.18 11.34 86.47 34.2 5.48 5.15 6.31 11.64 2.07 16.26s-10.27 4.49-16-.37c-17.44-14.89-37-25.31-60-28.33-27.87-3.66-52.61 4.34-75.19 20.23-3.67 2.58-7.11 5.5-10.56 8.37-5.43 4.5-11.47 4.61-15.62.16-4.31-4.61-3.79-10.82 1.53-15.88 20.07-19.09 44-30.16 71.37-33.69 2.81-.36 5.61-.74 8.43-.92 2.5-.15 5-.03 7.5-.03z",
  transform: "translate(.08 -.12)"
});

var _ref5$4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M129.21 130.69c21.71.76 41.26 7.21 56.6 23.7a10.36 10.36 0 0 1 0 14.48c-3.88 4-9.81 4.39-14.37.45-8.81-7.62-18.42-13.7-30-16.07-17.59-3.61-32.79 1.83-46.55 12.52-1.71 1.33-3.26 2.86-5 4.15-4.85 3.62-10.45 3.13-14.35-1.19-3.7-4.09-3.76-9.54.23-14 11.25-12.44 25.47-19.48 41.81-22.49 3.76-.66 7.58-1.01 11.63-1.55zM131 181.06A27.18 27.18 0 0 1 158 208c.07 14.58-12.32 27.18-26.83 27.28-14.69.09-27.19-12.13-27.33-26.71A27.3 27.3 0 0 1 131 181.06zm8.38 27a8 8 0 0 0-15.92-.24 8 8 0 1 0 15.92.24z",
  transform: "translate(.08 -.12)"
});

var UNUSABLE = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20255.73%20255.47%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23d2d2d2%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Ctitle%3Ewifi1%3C%2Ftitle%3E%3Crect%20class%3D%22cls-1%22%20width%3D%22255.73%22%20height%3D%22255.47%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M254.09%2C84.41a9.81%2C9.81%2C0%2C0%2C1-5.86%2C10.06c-4.48%2C2.2-8.6%2C1.43-12.53-1.69C227.88%2C86.58%2C220.29%2C80%2C212%2C74.53c-45.47-29.88-93-31.71-142-9.61A194.49%2C194.49%2C0%2C0%2C0%2C21%2C96.45c-5.52%2C4.86-12.17%2C4.78-16.41-.13S.91%2C85%2C6.3%2C80.35c37.45-32.1%2C79.9-52.13%2C130.11-51.84%2C38.62.22%2C72.26%2C14.73%2C102.31%2C38.32a112.39%2C112.39%2C0%2C0%2C1%2C11%2C9.36A16.4%2C16.4%2C0%2C0%2C1%2C254.09%2C84.41Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M131.15%2C81.24c33%2C.71%2C62.18%2C11.34%2C86.47%2C34.2%2C5.48%2C5.15%2C6.31%2C11.64%2C2.07%2C16.26s-10.27%2C4.49-16-.37c-17.44-14.89-37-25.31-60-28.33-27.87-3.66-52.61%2C4.34-75.19%2C20.23-3.67%2C2.58-7.11%2C5.5-10.56%2C8.37-5.43%2C4.5-11.47%2C4.61-15.62.16-4.31-4.61-3.79-10.82%2C1.53-15.88%2C20.07-19.09%2C44-30.16%2C71.37-33.69%2C2.81-.36%2C5.61-.74%2C8.43-.92C126.15%2C81.12%2C128.65%2C81.24%2C131.15%2C81.24Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M129.21%2C130.69c21.71.76%2C41.26%2C7.21%2C56.6%2C23.7a10.36%2C10.36%2C0%2C0%2C1%2C0%2C14.48c-3.88%2C4-9.81%2C4.39-14.37.45-8.81-7.62-18.42-13.7-30-16.07-17.59-3.61-32.79%2C1.83-46.55%2C12.52-1.71%2C1.33-3.26%2C2.86-5%2C4.15-4.85%2C3.62-10.45%2C3.13-14.35-1.19-3.7-4.09-3.76-9.54.23-14%2C11.25-12.44%2C25.47-19.48%2C41.81-22.49C121.34%2C131.58%2C125.16%2C131.23%2C129.21%2C130.69Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M131%2C181.06A27.18%2C27.18%2C0%2C0%2C1%2C158%2C208c.07%2C14.58-12.32%2C27.18-26.83%2C27.28-14.69.09-27.19-12.13-27.33-26.71A27.3%2C27.3%2C0%2C0%2C1%2C131%2C181.06Zm8.38%2C27a8%2C8%2C0%2C0%2C0-15.92-.24%2C8%2C8%2C0%2C1%2C0%2C15.92.24Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3C%2Fsvg%3E";

var _ref$5 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2$5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h255.73v255.47H0z"
});

var _ref3$5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M128.73 179.27a20 20 0 1 0 .19 40 20.4 20.4 0 0 0 19.83-20.16 20.1 20.1 0 0 0-20.02-19.84zm.41 26a6.1 6.1 0 0 1-6-6.18 5.89 5.89 0 0 1 11.77.18 6.09 6.09 0 0 1-5.77 5.96z",
  transform: "translate(.08 -.12)"
});

var _ref4$5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M255 127.76A126.25 126.25 0 1 0 128.71 254 126.39 126.39 0 0 0 255 127.76zm-237.5 0a111.2 111.2 0 0 1 194.63-73.51l-30.77 23.56a112.94 112.94 0 0 0-48.59-11.33c-37.13-.22-68.51 14.6-96.2 38.33-4 3.41-4.32 8.23-1.24 11.8s8.05 3.7 12.13.1A143.57 143.57 0 0 1 83.62 93.4c28.43-12.81 56.17-14.74 83-4.33l-23.09 17.68a111.72 111.72 0 0 0-14.68-1.29c-1.85 0-3.7-.09-5.54 0-2.08.13-4.16.41-6.23.68a91.59 91.59 0 0 0-52.77 24.9c-3.94 3.75-4.32 8.34-1.13 11.75s7.53 3.21 11.55-.12c2.55-2.13 5.09-4.28 7.8-6.19 13-9.17 27.05-14.77 42.38-15.5L36 189.13a110.63 110.63 0 0 1-18.54-61.37zM129 239a111 111 0 0 1-83.95-38l41.83-32a8.23 8.23 0 0 0 .86 1.13c2.88 3.19 7 3.56 10.61.88 1.28-1 2.42-2.09 3.69-3.07 10.17-7.9 21.41-11.93 34.42-9.26 8.55 1.76 15.65 6.25 22.17 11.89a7.46 7.46 0 0 0 10.62-.34 7.65 7.65 0 0 0 0-10.7c-9.6-10.33-21.44-15.33-34.59-17a49.89 49.89 0 0 0-12.57.1l-1 .14 25.64-19.63c13.38 3.36 25.11 10.19 35.78 19.3 4.22 3.59 8.69 3.66 11.8.27s2.53-8.21-1.52-12a90.52 90.52 0 0 0-30.79-19.2l19.82-15.17q3.42 1.93 6.81 4.16c6.14 4 11.75 8.91 17.54 13.5 2.9 2.3 5.95 2.87 9.26 1.25h.09a7.71 7.71 0 0 0 3-10.82 13.64 13.64 0 0 0-2-2.66 81.8 81.8 0 0 0-8.15-6.92q-6.24-4.89-12.76-9.06l25.63-19.62A110.64 110.64 0 0 1 239.93 130c-1.2 60.18-50.74 108.84-110.93 109z",
  transform: "translate(.08 -.12)"
});

var DISCONNECTED = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20255.73%20255.47%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23d2d2d2%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Ctitle%3Ewifi0%3C%2Ftitle%3E%3Crect%20class%3D%22cls-1%22%20width%3D%22255.73%22%20height%3D%22255.47%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M128.73%2C179.27a20%2C20%2C0%2C1%2C0%2C.19%2C40%2C20.4%2C20.4%2C0%2C0%2C0%2C19.83-20.16A20.1%2C20.1%2C0%2C0%2C0%2C128.73%2C179.27Zm.41%2C26a6.1%2C6.1%2C0%2C0%2C1-6-6.18%2C5.89%2C5.89%2C0%2C0%2C1%2C11.77.18A6.09%2C6.09%2C0%2C0%2C1%2C129.14%2C205.23Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M255%2C127.76A126.25%2C126.25%2C0%2C1%2C0%2C128.71%2C254%2C126.39%2C126.39%2C0%2C0%2C0%2C255%2C127.76Zm-237.5%2C0A111.2%2C111.2%2C0%2C0%2C1%2C212.13%2C54.25L181.36%2C77.81a112.94%2C112.94%2C0%2C0%2C0-48.59-11.33c-37.13-.22-68.51%2C14.6-96.2%2C38.33-4%2C3.41-4.32%2C8.23-1.24%2C11.8s8.05%2C3.7%2C12.13.1A143.57%2C143.57%2C0%2C0%2C1%2C83.62%2C93.4c28.43-12.81%2C56.17-14.74%2C83-4.33l-23.09%2C17.68a111.72%2C111.72%2C0%2C0%2C0-14.68-1.29c-1.85%2C0-3.7-.09-5.54%2C0-2.08.13-4.16.41-6.23.68a91.59%2C91.59%2C0%2C0%2C0-52.77%2C24.9c-3.94%2C3.75-4.32%2C8.34-1.13%2C11.75s7.53%2C3.21%2C11.55-.12c2.55-2.13%2C5.09-4.28%2C7.8-6.19%2C13-9.17%2C27.05-14.77%2C42.38-15.5L36%2C189.13A110.63%2C110.63%2C0%2C0%2C1%2C17.46%2C127.76ZM129%2C239a111%2C111%2C0%2C0%2C1-83.95-38l41.83-32a8.23%2C8.23%2C0%2C0%2C0%2C.86%2C1.13c2.88%2C3.19%2C7%2C3.56%2C10.61.88%2C1.28-1%2C2.42-2.09%2C3.69-3.07%2C10.17-7.9%2C21.41-11.93%2C34.42-9.26%2C8.55%2C1.76%2C15.65%2C6.25%2C22.17%2C11.89a7.46%2C7.46%2C0%2C0%2C0%2C10.62-.34%2C7.65%2C7.65%2C0%2C0%2C0%2C0-10.7c-9.6-10.33-21.44-15.33-34.59-17a49.89%2C49.89%2C0%2C0%2C0-12.57.1l-1%2C.14%2C25.64-19.63c13.38%2C3.36%2C25.11%2C10.19%2C35.78%2C19.3%2C4.22%2C3.59%2C8.69%2C3.66%2C11.8.27s2.53-8.21-1.52-12A90.52%2C90.52%2C0%2C0%2C0%2C162%2C111.51l19.82-15.17q3.42%2C1.93%2C6.81%2C4.16c6.14%2C4%2C11.75%2C8.91%2C17.54%2C13.5%2C2.9%2C2.3%2C5.95%2C2.87%2C9.26%2C1.25l.09%2C0a7.71%2C7.71%2C0%2C0%2C0%2C3-10.82%2C13.64%2C13.64%2C0%2C0%2C0-2-2.66%2C81.8%2C81.8%2C0%2C0%2C0-8.15-6.92q-6.24-4.89-12.76-9.06l25.63-19.62A110.64%2C110.64%2C0%2C0%2C1%2C239.93%2C130C238.73%2C190.18%2C189.19%2C238.84%2C129%2C239Z%22%20transform%3D%22translate%280.08%20-0.12%29%22%2F%3E%3C%2Fsvg%3E";

var defaults$1 = {
  statusImages: {
    EXCELLENT: EXCELLENT,
    GREAT: GREAT,
    OKAY: OKAY,
    WEAK: WEAK,
    UNUSABLE: UNUSABLE,
    DISCONNECTED: DISCONNECTED
  },
  style: {
    height: '3em'
  },
  alt: ''
};

var WiFiIndicator = function (_Component) {
  inherits(WiFiIndicator, _Component);

  function WiFiIndicator() {
    classCallCheck(this, WiFiIndicator);
    return possibleConstructorReturn(this, (WiFiIndicator.__proto__ || Object.getPrototypeOf(WiFiIndicator)).apply(this, arguments));
  }

  createClass(WiFiIndicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          strength = _props.strength,
          statusImages = _props.statusImages,
          rest = objectWithoutProperties(_props, ['strength', 'statusImages']);

      return React.createElement('img', _extends({
        src: statusImages[strength]
      }, rest));
    }
  }]);
  return WiFiIndicator;
}(Component);

WiFiIndicator.propTypes = propTypes;
WiFiIndicator.defaultProps = defaults$1;

/**
 * dBm is a negative number where:
 * -30 dBm is the maximum achievable signal strength. Heuristic show -42 is still an amazing, but realistic signal strength.
 * -90 dBm is unusable and approaching or drowning in the noise floor. Any functionality is highly unlikely.
 * @param {*} dBm
 * @return {SignalStrength}
 */
var DBMToSignalStrength = function DBMToSignalStrength(dBm) {
  if (typeof dBm !== 'string' && typeof dBm !== 'number' || dBm === '') {
    return SignalStrength.DISCONNECTED;
  }

  var num = Number.isFinite(dBm) ? dBm : Number(dBm);

  if (num >= -46) {
    return SignalStrength.EXCELLENT;
  }
  if (num >= -60) {
    return SignalStrength.GREAT;
  }
  if (num >= -72) {
    return SignalStrength.OKAY;
  }
  if (num >= -80) {
    return SignalStrength.WEAK;
  }
  if (num >= -90) {
    return SignalStrength.UNUSABLE;
  }
  return SignalStrength.DISCONNECTED;
};

export default WiFiIndicator;
export { DBMToSignalStrength, SignalStrength };
//# sourceMappingURL=index.es.js.map
